export const ADMIN = 'ADMIN';
export const TEACHER = 'TEACHER';
export const STUDENT = 'STUDENT';